import { render, staticRenderFns } from "./PurgerForPlex.vue?vue&type=template&id=4972de1e&scoped=true&"
import script from "./PurgerForPlex.vue?vue&type=script&lang=js&"
export * from "./PurgerForPlex.vue?vue&type=script&lang=js&"
import style0 from "./PurgerForPlex.vue?vue&type=style&index=0&id=4972de1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972de1e",
  null
  
)

export default component.exports